import { initialUpsellLeadsState } from ".";

export const upsellLeadsReducer = (state = initialUpsellLeadsState) => state;
